/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

export const defaultPreText: Record<string, string> = {
  'Legendary Actions': "The [MON] can take 3 legendary actions, choosing from the options below. Only one legendary action option can be used at a time and only at the end of another creature's turn. The [MON] regains spent legendary actions at the start of its turn.",
  'Mythic':            "If the [MON]'s mythic trait is active, it can use the options below as legendary actions for 1 hour after using {Some Ability}.",
  'Lair Actions':      "When fighting inside its lair, the [MON] can invoke the ambient magic to take lair actions. On initiative count 20 (losing initiative ties), the [MON] can take one lair action to cause one of the following effects:",
  'Regional Effects':  "The region containing the [MON]'s lair is warped by the creature's presence, which creates one or more of the following effects:",
};

export const defaultPostText: Record<string, string> = {
  'Lair Actions':     "The [MON] can't repeat an effect until they have all been used, and it can't use the same effect two rounds in a row.",
  'Regional Effects': "If the [MON] dies, the effects fade over the course of 3d10 days.",
};
